module.exports = __webpack_public_path__ + "img/ANTENNA 4 PURPLE.aad163c.svg";